/**
 * Colonna immagine + contenuto, uguale per tutte le card della cronologia.
 *
 * A sinistra un'immagine da 40px che dice subito "chi" o "cosa": la foto di chi
 * ha scritto la nota, dell'assegnatario dell'attivita', del contatto della chat,
 * la creativita' dell'annuncio. Dove una foto vera non c'e' (newsletter, email)
 * sta una tessera nel colore della famiglia. A destra il contenuto, allineato
 * sempre allo stesso margine: e' cio' che rende le card riconoscibili anche
 * quando il testo e' diverso.
 */
import React from 'react';

interface CardMediaProps {
  media: React.ReactNode;
  children: React.ReactNode;
}

export const CardMedia: React.FC<CardMediaProps> = ({ media, children }) => (
  <div className="flex gap-3">
    <div className="flex-shrink-0">{media}</div>
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);
